// frontend/src/pages/ProveedoresPage.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FiPlus, FiEdit, FiTrash2 } from 'react-icons/fi';
import { proveedorService } from '../services/onebaseService';
import CrearEditarProveedorModal from '../components/CrearEditarProveedorModal';
import Loading from '../components/Loading';

const ProveedoresPage = () => {
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [proveedorEditando, setProveedorEditando] = useState(null);
  const [filtroNombre, setFiltroNombre] = useState('');

  useEffect(() => {
    cargarProveedores();
  }, []);

  const cargarProveedores = async () => {
    try {
      setLoading(true);
      const response = await proveedorService.getAll({ status: 'activo' });
      setProveedores(response.data?.results || response.data || []);
    } catch (error) {
      console.error('Error al cargar proveedores:', error);
      toast.error('Error al cargar los proveedores');
    } finally {
      setLoading(false);
    }
  };

  const handleCrear = () => {
    setProveedorEditando(null);
    setShowModal(true);
  };

  const handleEditar = (proveedor) => {
    setProveedorEditando(proveedor);
    setShowModal(true);
  };

  const handleEliminar = async (proveedor) => {
    if (!window.confirm(`¿Está seguro de eliminar el proveedor "${proveedor.nombre}"?`)) {
      return;
    }

    try {
      await proveedorService.delete(proveedor.id);
      toast.success('Proveedor eliminado correctamente');
      cargarProveedores();
    } catch (error) {
      console.error('Error al eliminar proveedor:', error);
      toast.error('Error al eliminar el proveedor');
    }
  };

  const proveedoresFiltrados = proveedores.filter(proveedor =>
    proveedor.nombre.toLowerCase().includes(filtroNombre.toLowerCase()) ||
    (proveedor.rut && proveedor.rut.toLowerCase().includes(filtroNombre.toLowerCase())) ||
    (proveedor.email && proveedor.email.toLowerCase().includes(filtroNombre.toLowerCase()))
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <div style={{
      maxWidth: '1600px',
      margin: '0 auto',
      padding: '2rem'
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        borderRadius: '16px',
        padding: '2rem',
        marginBottom: '2rem',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <h1 style={{
          margin: 0,
          fontSize: '2rem',
          color: '#102826',
          fontWeight: 700
        }}>
          Proveedores
        </h1>

        <div style={{ flex: 1, minWidth: '250px' }}>
          <input
            id="filtro-nombre"
            type="text"
            placeholder="🔍 Buscar por nombre, RUT o email..."
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '0.95rem',
              transition: 'all 0.2s ease',
              outline: 'none'
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = '#10b981';
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(16, 185, 129, 0.1)';
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = '#d1d5db';
              e.currentTarget.style.boxShadow = 'none';
            }}
          />
        </div>
        <button
          onClick={handleCrear}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '0.95rem',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            background: 'linear-gradient(135deg, #10b981 0%, #0ea574 100%)',
            color: 'white',
            flexShrink: 0
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 12px -2px rgba(0, 0, 0, 0.15)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
          }}
        >
          <FiPlus /> Nuevo Proveedor
        </button>
      </div>

      {/* Table Container */}
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
        overflow: 'hidden'
      }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse'
          }}>
            <thead>
              <tr style={{
                background: 'linear-gradient(135deg, #10b981 0%, #0ea574 100%)'
              }}>
                <th style={{
                  padding: '1rem',
                  textAlign: 'left',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>Nombre</th>
                <th style={{
                  padding: '1rem',
                  textAlign: 'left',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>RUT</th>
                <th style={{
                  padding: '1rem',
                  textAlign: 'left',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>Contacto Principal</th>
                <th style={{
                  padding: '1rem',
                  textAlign: 'left',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>Email</th>
                <th style={{
                  padding: '1rem',
                  textAlign: 'left',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>Teléfono</th>
                <th style={{
                  padding: '1rem',
                  textAlign: 'left',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>Dirección</th>
                <th style={{
                  padding: '1rem',
                  textAlign: 'center',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: 'white'
                }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {proveedoresFiltrados.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{
                    textAlign: 'center',
                    padding: '3rem 2rem',
                    color: '#9ca3af',
                    fontSize: '1rem'
                  }}>
                    {proveedores.length === 0
                      ? 'No hay proveedores registrados'
                      : 'No hay proveedores que coincidan con el filtro'
                    }
                  </td>
                </tr>
              ) : (
                proveedoresFiltrados.map((proveedor, index) => (
                  <tr
                    key={proveedor.id}
                    style={{
                      borderBottom: index < proveedoresFiltrados.length - 1 ? '1px solid #e5e7eb' : 'none',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = '#f9fafb';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <td style={{
                      padding: '1rem',
                      color: '#111827',
                      verticalAlign: 'middle',
                      fontSize: '0.875rem'
                    }}>
                      <strong style={{ fontWeight: 600 }}>{proveedor.nombre}</strong>
                    </td>
                    <td style={{
                      padding: '1rem',
                      color: '#374151',
                      verticalAlign: 'middle',
                      fontSize: '0.875rem'
                    }}>
                      {proveedor.rut || '-'}
                    </td>
                    <td style={{
                      padding: '1rem',
                      color: '#374151',
                      verticalAlign: 'middle',
                      fontSize: '0.875rem'
                    }}>
                      {proveedor.contacto_principal || '-'}
                    </td>
                    <td style={{
                      padding: '1rem',
                      color: '#374151',
                      verticalAlign: 'middle',
                      fontSize: '0.875rem'
                    }}>
                      {proveedor.email || '-'}
                    </td>
                    <td style={{
                      padding: '1rem',
                      color: '#374151',
                      verticalAlign: 'middle',
                      fontSize: '0.875rem'
                    }}>
                      {proveedor.telefono || '-'}
                    </td>
                    <td style={{
                      padding: '1rem',
                      color: '#374151',
                      verticalAlign: 'middle',
                      fontSize: '0.875rem'
                    }}>
                      {proveedor.direccion || '-'}
                    </td>
                    <td style={{
                      padding: '1rem',
                      verticalAlign: 'middle'
                    }}>
                      <div style={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <button
                          onClick={() => handleEditar(proveedor)}
                          title="Editar Proveedor"
                          style={{
                            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'white',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            transition: 'all 0.2s',
                            width: '36px',
                            height: '36px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.4)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          <FiEdit size={18} />
                        </button>
                        <button
                          onClick={() => handleEliminar(proveedor)}
                          title="Eliminar Proveedor"
                          style={{
                            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'white',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            transition: 'all 0.2s',
                            width: '36px',
                            height: '36px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.4)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                          }}
                        >
                          <FiTrash2 size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <CrearEditarProveedorModal
          proveedor={proveedorEditando}
          onClose={() => {
            setShowModal(false);
            setProveedorEditando(null);
          }}
          onSuccess={() => {
            cargarProveedores();
            setShowModal(false);
            setProveedorEditando(null);
          }}
        />
      )}
    </div>
  );
};

export default ProveedoresPage;
